import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/app/app';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import * as Sentry from '@sentry/browser';
import './components/app/index.scss';

const { REACT_APP_SENTRY_DSN } = process.env;
if (REACT_APP_SENTRY_DSN) {
    Sentry.init({ dsn: REACT_APP_SENTRY_DSN });
}

ReactDOM.render(
    <BrowserRouter>
        <App />
    </BrowserRouter>,
    document.getElementById('root')
);

// If you want your app to work offline and loadCAs faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
